module.exports = __webpack_public_path__ + "6264cbba7002f60a841c645e37f3c73a.png";